<template>
	<section class="content checkout-content d-flex justify-content-center pt-0 wp_MarginBottomAllPage">
		<div class="clientauth-wrapper mt-5">
			<div class="col-12">
				<div class="form-signin">
					<h1 class="h3 mb-4 font-weight-normal text-center"
									id="sign-in-form-head-tenant-registration"
									data-test="BankTenantFormHeading">
						Tenant Registration
					</h1>
					<tenant-login-form />
					<!--<hr>-->
					<!--<p class="newuser"-->
								<!--data-test="BankTenantSignInFormNewCustomer"-->
								<!--id="BankTenantSignInFormNewCustomer">New Customer?-->
						<!--<a href=""-->
									<!--@click.prevent="$router.push('/signup')"-->
									<!--data-test="BankTenantSignInFormRegisterLink"-->
									<!--id="BankTenantSignInFormRegisterLink"-->
						<!--&gt;-->
							<!--Register-->
						<!--</a>-->
					<!--</p>-->
					<!--<p class="newuser">Already a Customer?-->
						<!--<a href=""-->
									<!--@click.prevent="$router.push('/login')"-->
									<!--data-test="BankTenantLoginFormRegisterLink"-->
						<!--&gt;-->
							<!--Login-->
						<!--</a>-->
					<!--</p>-->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import TenantLoginForm from './forms/TenantLoginForm'

export default {
	components: { TenantLoginForm },
	name: 'tenant-registration'
}
</script>

<style scoped>

</style>
